<!--
 * @Description: 
 * @FilePath: \京东互动积分B端\src\components\user-inform.vue
-->
<!--头部导航-->
<template>
  <div class="container">
    <div class="titileDefinition">
      <i @click="out_page" class="el-icon-arrow-left"></i>
      账号设置
    </div>

    <div class="input-content-box">
      <div class="background">
        <span class="title"></span>&nbsp;
        <span class="tips">联系人信息</span>
      </div>
      <div class="input-box">
        <div class="item">
          &nbsp;&nbsp;
          <span class="fenHao">* </span>
          <span class="item-name">姓名</span>
          <el-input
            v-model="userInfo.contactName"
            :disabled="editDisabled"
            class="input"
            :placeholder="userInfo.contactName == '' && !editDisabled ? '请输入姓名' : ''"
            :maxlength="50"
            size="small"
          ></el-input>
        </div>
        <div class="item">
          &nbsp;&nbsp;
          <span class="fenHao">* </span>
          <span class="item-name">QQ</span>
          <el-input
            class="input"
            oninput="value=value.replace(/[^\d]/g,'')"
            :placeholder="userInfo.qq == '' && !editDisabled ? '用于软件指导' : ''"
            :disabled="editDisabled"
            v-model="userInfo.qq"
            size="small"
          ></el-input>
        </div>
        <div class="item">
          <span class="fenHao">* </span>
          <span style="margin-right: 11px">手机号</span>
          <!--  @change="checkPhone"
                  id="phone"
                  @input="verificationCode" -->

          <el-input
            v-model="userInfo.mobile"
            @change="checkPhone"
            :disabled="editDisabled"
            id="phone"
            @input="verificationCode"
            class="input"
            oninput="value=value.replace(/[^\d]/g,'')"
            :maxlength="11"
            placeholder="仅用于实时监控店铺数据"
            size="small"
          ></el-input>
        </div>
        <div class="item" style="margin-bottom: 40px">
          <span>&nbsp;验证码</span>&nbsp;&nbsp;
          <el-input v-model="message.vcode" type="number" :disabled="editDisabled" class="code-input" size="small"></el-input>
          <el-button
            class="code-button"
            plain
            size="small"
            v-zoom="{ from: pageName, name: buttonContent }"
            @click="getMesaage"
            :disabled="dis || editDisabled"
            >{{ buttonContent }}</el-button
          >
        </div>
        <div style="text-align: left;border-top: 1px solid #ddd;">
          <el-button @click="out_page" class="b2" size="small" v-zoom="{ from: pageName, name: '返回' }" style="margin-top: 10px; width: 98px"
            >返回</el-button
          >

          <el-button
            v-if="isBtnState == '1'"
            @click="saveSetting"
            class="b1"
            size="small"
            v-zoom="{ from: pageName, name: '确定' }"
            style="margin-top: 10px; width: 98px"
            >确定</el-button
          >
          <el-button
            v-if="isBtnState == '2'"
            @click="(editDisabled = false), (isBtnState = '1')"
            class="b1"
            size="small"
            v-zoom="{ from: pageName, name: '修改' }"
            style="margin-top: 10px; width: 98px"
            >修改</el-button
          >&nbsp;
        </div>
      </div>
      <div class="background" style="margin-top: 20px;">
        <span class="title"></span>&nbsp;
        <span class="tips">导出设置</span>
      </div>
      <div class="background" style="margin-top: 10px;width: 800px;padding: 10px 20px 10px 20px;height: auto;">
        <div class="tips" style="width: 100%;">1.为保证客户数据安全性，防止信息泄露，导出系统短信效果、数据分析等可设置验证手机号！</div>
        <div class="tips" style="width: 100%;">2.每次更改设置，需要验证手机号</div>
      </div>
      <div class="item fvStart" style="margin-top: 20px; margin-left: 10px;">
        <span class="item-name" style="margin-right: 10px;">导出数据身份验证</span>
        <div class="item-right">
          <el-switch
            v-model="switchValue"
            @change="swichChange">
          </el-switch>
          <div class="export-tip">
            导出活动数据时，是否需要通过验证码后才能下载
          </div>
        </div>
      </div>
    </div>
    
    <el-dialog
      title="身份验证"
      :visible.sync="sendDialog"
      custom-class="system-dialog"
      :append-to-body="true"
      width="600px"
      @close="closeExportVerify"
    >
      <div class="form-box">
        <div class="ruloBox tipBg">
          <span class="desc">
              <i class="el-alert__icon el-icon-info"></i>
          </span>
          <span style="padding: 12px 0 0 7px;">为了保护您的数据安全，变更【导出数据身份验证】需要手机验证</span>
        </div>
        <div class="form-item">
          <div class="item-label">
            手机号：
          </div>
          <div class="item-value">
            <el-input
              disabled
              placeholder="请输入..."
              v-model="userInfo.mobile"
              style="width: 280px"
            ></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">
            验证码：
          </div>
          <div class="item-value">
            <el-input
              placeholder="请输入"
              v-model="code"
              style="width: 170px; margin-right: 12px"
            ></el-input>
            <el-button
              type="primary"
              :disabled="codeDisabled"
              @click="getCode"
              >{{ codeMsg }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="save-btn" style="margin-top: 30px;">
        <el-button
          type="primary"
          size="small"
          style="width: 100px"
          @click="saveExportSetting"
          >确定</el-button
        >
        <el-button @click="sendDialog = false" size="small" style="width: 100px"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { checkCodeSet, querySellerSetting, updateSellerSetting } from "@/api/userInform"; //判断是否有绑定手机号
import { getSellerCheckCode } from "@/api/paradiseAndTaskCommonController.js";
export default {
  name: "user-inform",
  props: {},
  data() {
    return {
      pageName: "账户设置",
      userInfo: {
        //获取账号设置的信息
        contactName: "", // 联系人名称
        expiredIn: "",
        invalidateDate: "",
        isOrder: "", // 是否订购悦互动
        mobile: "", //  手机号
        picPath: "", //  店铺图片
        qq: "",
        sellerNick: "",
        sellerPin: "", //  商家Pin
        venderId: "",
        venderType: "",
      },
      message: {
        //验证码
        vcode: "",
      },
      buttonContent: "获取验证码",
      editDisabled: true, //
      dis: false, //验证码
      totalTime: 60,
      isBtnState: "2",
      
      switchValue: false,
      sendDialog: false, // 短信验证弹窗
      code: "", // 验证码
      phone: "", //客户的手机号
      codeMsg: "获取验证码", // 按钮上的文字
      codeDisabled: false, // 按钮可点击？（是否绑定手机）
      timer: null, //验证码定时
      countdown: 60,
    };
  },
  mounted() {
    this.querySellerSetting();
  },

  methods: {
    // 验证身份开关改变
    swichChange(val) {
      console.log(val)
      this.switchValue = !this.switchValue;
      this.sendDialog = !this.sendDialog;
    },
    toChangePhone() {
      //跳转到帐号设置绑定手机
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: {
          to: "/backstage/accountset",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    getCode() {
      // if (this.userInfo.mobile.indexOf("*") > -1) {
      //   this.$message.error("手机号码有误,请重填");
      //   return;
      // }
      // 验证码60秒倒计时
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
          }else {
            this.$message.error(res.message)
          }
        });
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = "重新发送(" + this.countdown + ")";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "获取验证码";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },

    out_page() {
      this.$emit("out_page");
    },

    querySellerSetting() {
      querySellerSetting({})
        .then((res) => {
          this.userInfo = res.data;
          this.switchValue = res.data.isOpenDownloadRemind == 0;
          console.log("res.data.mobile", res.data.mobile);
          if (res.data.mobile && res.data.mobile != "") {
          } else {
            this.dis = true;
          }
        })
        .catch((e) => {});
    },

    //手机正则表达判断
    checkPhone() {
      var phone = document.getElementById("phone").value;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message("手机号码有误,请重填");
        return false;
      }
      if (this.userInfo.mobile.length < 11) {
        this.dis = true;
      }
    },
    verificationCode() {
      if (this.userInfo.mobile.length < 11) {
        this.dis = true;
      } else {
        this.dis = false;
      }
    },

    //发送验证码
    getMesaage() {
      if (this.userInfo.mobile.indexOf("*") > -1) {
        this.$message.error("手机号码有误,请重填");
        return;
      }
      this.dis = !this.dis;

      checkCodeSet({
        bindingPhone: this.userInfo.mobile,
      })
        .then((res) => {})
        .catch((e) => {});
      let _that = this;
      _that.dis = true;
      let clock = window.setInterval(() => {
        _that.totalTime--;
        _that.buttonContent = _that.totalTime + "s后重新发送";
        if (_that.totalTime === 0) {
          window.clearInterval(clock);
          _that.totalTime = 60;
          _that.buttonContent = "获取验证码";
          _that.dis = false;
        }
      }, 1000);
      this.timer = clock;
    },

    // 保存导出设置
    saveExportSetting() {
      if (this.code == "") {
        this.$message.error("验证码不能为空");
        return;
      }
      updateSellerSetting({
        mobile: this.userInfo.mobile,
        vcode: this.code,
        isOpenDownloadRemind: this.switchValue? 1 : 0,
      }).then((res) => {
          if (res.code == "0") {
            this.$message.error(res.message);
          } else {
            this.$message.success("保存设置成功");
            clearInterval(this.timer);
            this.codeMsg = "获取验证码";
            this.countdown = 60;
            this.timer = null;
            this.codeDisabled = false;
            this.code = "";
            this.querySellerSetting();
            this.sendDialog = !this.sendDialog;
          }
        })
    },

    //保存设置
    saveSetting() {
      if (this.userInfo.contactName && this.userInfo.contactName.length > 50) {
        this.$message.error("姓名为不超过50个字的汉字或英文");
        return;
      }
      if (this.message.vcode == "") {
        this.$message.error("验证码不能为空");
        return;
      }
      window.clearInterval(this.timer);

      this.totalTime = 60;
      this.buttonContent = "获取验证码";
      this.dis = false;

      updateSellerSetting({
        contactName: this.userInfo.contactName,
        mobile: this.userInfo.mobile,
        qq: this.userInfo.qq,
        vcode: this.message.vcode,
      })
        .then((res) => {
          console.log(res);
          if (res.code == "0") {
            this.$message.error(res.message);
          } else {
            this.$message.success("保存设置成功");
            this.editDisabled = true;
            this.message.vcode = "";
            this.querySellerSetting();
            this.$emit("out_page");
          }
        })
        .catch((err) => {});
    },
    closeExportVerify() {
      this.querySellerSetting();
      this.sendDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background: #f5f8fa;

  .titileDefinition {
    min-width: 1046px;
    height: 57px;
    background-color: #fff;
    line-height: 57px;
    padding: 0 30px;
    font-size: 16px;
    color: #2e3458;
    font-weight: bold;
    margin: 20px;
    border: 1px solid rgba(230, 230, 230, 1);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  .input-content-box {
    min-width: 1046px;
    background-color: #fff;
    margin: 20px;
    padding: 20px 30px;
    border: 1px solid rgba(230, 230, 230, 1);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;

    .background {
      height: 32px;
      background: rgba(250, 250, 250, 1);
      opacity: 1;
      line-height: 32px;
      padding-left: 12px;
      .title {
        display: inline-block;
        width: 2px;
        height: 14px;
        background: #7b61ff;
        opacity: 1;
        border-radius: 3px;
        vertical-align: middle;
      }
      .tips {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        vertical-align: middle;
      }
    }
    .tips-box {
      width: 818px;
      height: 42px;
      line-height: 42px;
      position: relative;
      font-size: 14px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 25px;
      .background-span {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.1;
        top: 0;
        left: 0;
      }
    }
    .b1 {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #7b61ff;
      }
    }
    .b2 {
      width: 98px;
      height: 32px;
      color: #666666;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;

        background: rgba(123, 97, 255, 0.1);
      }
      &:active {
        color: #7b61ff;
        border: 1px solid #7b61ff;

        background: rgba(123, 97, 255, 0.1);
      }
    }
    .input-box {
      font-size: 14px;
      margin-top: 10px;
      padding-left: 55px;
      .item {
        margin-bottom: 10px;
        .item-name {
          display: inline-block;
          vertical-align: middle;
          // color: #333333;
          width: 40px;
        }
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 300px;
        }
        .code-input {
          display: inline-block;
          vertical-align: middle;
          width: 156px;
          margin-right: 12px;
        }
        // .code-btn{
        //   width:130px;
        // }
        .code-button {
          display: inline-block;
          vertical-align: middle;
          width: 130px;
          height: 32px;
          line-height: 30px;
          text-align: center;
          border-radius: 6px;
          background-color: #fff;
          cursor: pointer;
          > span {
            display: inline-block;
            position: relative;
            top: -12px;
          }
        }
      }
      .save-button {
        width: 167px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        margin-left: 60px;
      }
      .save-button:hover {
        opacity: 0.8;
      }
    }
    .fvStart {
      display: flex;
    }
    .item-right {
      .export-tip {
        margin-top: 10px;
        color: red;
        line-height: 20px;
      }
    }
  }

  .fenHao {
    width: 6px;
    height: 8px;
    color: rgba(255, 58, 39, 1);
    opacity: 1;
    vertical-align: middle;
    margin-left: -5px;
  }
}

.el-icon-arrow-left {
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.hug-send {
  overflow: hidden;
  margin-top: 20px;
  .send-left {
    float: left;
    height: 20px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 20px;
    color: rgba(102, 102, 102, 1);
    margin-left: 50px;
  }
  .send-right {
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 21px;
    color: rgba(51, 51, 51, 1);
    width: 220px;
  }
  .send-right2 {
    height: 32px;
    border-bottom: 2px solid rgba(245, 245, 245, 1);
  }
  .codeBtn {
    border: none;
    width: 110px;
    display: inline-block;
    line-height: 26px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    outline-style: none;
  }
  .getNumber {
    display: inline-block;

    width: 100px;
    border: none;
    background: none;
    outline-style: none;
    color: rgba(153, 153, 153, 1);
    line-height: 26px;
  }
  .msg {
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 14px;
    color: rgba(153, 153, 153, 1);
    text-align: center;
  }
}
.ruloBox {
  // width: 860px;
  height: 43px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.desc {
  i {
    opacity: 0.7;
    color: #7B61FF;
  }
  color: #999;
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-label2 {
        display: inline-block;
        width: 100px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
</style>
